import PropTypes from 'prop-types';
import { Typography, Card, Divider, TableRow, TableCell, Table, TableHead, TableBody, TableContainer, Paper, Box, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState, useEffect } from 'react';
import * as React from 'react';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const CampaignStatusList = (props) => {
  const theme = useTheme();
  const { statusAndSource, qualification } = props;
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState([]);

  useEffect(() => {
    if (qualification !== undefined) {
      if (qualification.length > 0) {
        const tempRows = [];
        const total = { id: 800, name: 'Total' };
        qualification.forEach((qual) => {
          total[qual] = { number: 0 };
        });
        let subTotalHRow = 0;
        
        Object.keys(statusAndSource).forEach((source) => {
          let row = { id: source, name: source };
          const totalHRow = { number: 0 };
          qualification.forEach((status) => {
            row[status] = statusAndSource[source][status];
            total[status].number += statusAndSource[source][status].number;
            totalHRow.number += statusAndSource[source][status].number;
          });
          subTotalHRow += totalHRow.number;

          // partie historique
          const historic = {};
          Object.keys(statusAndSource[source].historique).forEach((date) => {
            historic[date] = statusAndSource[source]['historique'][date];
            let totalNumber = 0;
            Object.keys(statusAndSource[source]['historique'][date]).forEach((data) => {
              totalNumber += statusAndSource[source]['historique'][date][data].number;
            });
            historic[date].total = { number: totalNumber };
          });

          row = { ...row, totalH: totalHRow, historic };
          tempRows.push(row);
        });
        total.totalH = { number: subTotalHRow };
        tempRows.push(total);

        setRows(tempRows);
        const tempOpen = [];
        Object.keys(statusAndSource).forEach(() => tempOpen.push(false));
        tempOpen.push(false);
        setOpen(tempOpen);
      }
    }
  }, [qualification, statusAndSource]);

  const handleOpen = (index) => {
    const tempOpen = [...open];
    tempOpen[index] = !tempOpen[index];
    setOpen(tempOpen);
  };

  return (
    <Card
      sx={{
        borderRadius: '24px',
        boxShadow: '0 4px 18px 0 rgba(0,0,0,0.03)',
        border: '1px solid',
        borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255,255,255,0.08)',
        overflow: 'hidden'
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{ p: 2.5, fontWeight: 700, color: theme.palette.text.primary }}
      >
        Nombre de prospects par source et par statut
      </Typography>
      <Divider />
      <TableContainer component={Paper} sx={{ boxShadow: 'none', background: 'transparent' }}>
        <Table aria-label="simple table">
          <TableHead
            sx={{
              backgroundColor: theme.palette.mode === 'light' ? '#f8fafc' : 'rgba(255,255,255,0.02)',
              borderBottom: `2px solid ${theme.palette.divider}`
            }}
          >
            <TableRow>
              <TableCell sx={{ width: 60 }} />
              <TableCell
                sx={{
                  fontWeight: 700,
                  color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
                  py: 2,
                  textTransform: 'uppercase',
                  fontSize: '0.75rem',
                  letterSpacing: '0.5px'
                }}
              >
                Nom
              </TableCell>
              {qualification.map((status) => (
                <TableCell
                  key={status}
                  align="right"
                  sx={{
                    fontWeight: 700,
                    color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
                    py: 2,
                    textTransform: 'uppercase',
                    fontSize: '0.75rem',
                    letterSpacing: '0.5px'
                  }}
                >
                  {status}
                </TableCell>
              ))}
              <TableCell
                align="right"
                sx={{
                  fontWeight: 700,
                  color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
                  py: 2,
                  textTransform: 'uppercase',
                  fontSize: '0.75rem',
                  letterSpacing: '0.5px'
                }}
              >
                Total
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <React.Fragment key={row.name || row.id}>
                <TableRow
                  sx={{
                    '& > *': { borderBottom: 'unset' },
                    transition: 'background-color 0.2s ease',
                    backgroundColor: row.name === 'Total' ? (theme.palette.mode === 'light' ? '#f8fafc' : 'rgba(255,255,255,0.01)') : 'inherit',
                    '&:hover': {
                      backgroundColor: row.name === 'Total' ? '' : (theme.palette.mode === 'light' ? 'rgba(59, 130, 246, 0.02)' : 'rgba(255, 255, 255, 0.02)')
                    }
                  }}
                >
                  <TableCell sx={{ py: 1.5, borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)' }}>
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={() => handleOpen(index)}
                    >
                      {open[index] && row.name !== 'Total' ? <KeyboardArrowUpIcon /> : !open[index] && row.name !== 'Total' ? <KeyboardArrowDownIcon /> : ''}
                    </IconButton>
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ py: 1.5, borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)' }}
                  >
                    <Typography
                      sx={{
                        fontWeight: row.name === 'Total' || open[index] ? 700 : 500,
                        fontSize: open[index] && row.name !== 'Total' ? '1.1rem' : '0.875rem',
                        color: theme.palette.text.primary
                      }}
                    >
                      {row.name}
                    </Typography>
                  </TableCell>
                  {qualification.map((status) => (
                    <TableCell
                      key={status}
                      align="right"
                      sx={{
                        py: 1.5,
                        fontWeight: row.name === 'Total' ? 700 : 500,
                        color: theme.palette.text.primary,
                        borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)'
                      }}
                    >
                      {row[status].number === null ? 0 : row[status].number}
                    </TableCell>
                  ))}
                  <TableCell
                    align="right"
                    sx={{
                      py: 1.5,
                      fontWeight: 700,
                      color: theme.palette.text.primary,
                      borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)'
                    }}
                  >
                    {row.totalH.number === undefined ? 0 : row.totalH.number}
                  </TableCell>
                </TableRow>
                <TableRow>
                  {row.name !== 'Total' && (
                    <TableCell
                      style={{ paddingBottom: 0, paddingTop: 0 }}
                      colSpan={qualification.length + 3}
                      sx={{ borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)' }}
                    >
                      <Collapse
                        in={open[index]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Box sx={{ margin: 2, p: 2, borderRadius: '16px', border: '1px solid', borderColor: theme.palette.divider, backgroundColor: theme.palette.mode === 'light' ? '#f8fafc' : 'rgba(255,255,255,0.01)' }}>
                          <Typography
                            variant="subtitle2"
                            gutterBottom
                            component="div"
                            sx={{ fontWeight: 700, mb: 2, color: theme.palette.primary.main }}
                          >
                            Historique des réinjections
                          </Typography>
                          <Table size="small" aria-label="purchases">
                            <TableHead
                              sx={{
                                backgroundColor: theme.palette.mode === 'light' ? '#fff' : 'rgba(0,0,0,0.1)',
                                borderBottom: `2px solid ${theme.palette.divider}`
                              }}
                            >
                              <TableRow>
                                <TableCell
                                  align="right"
                                  sx={{
                                    fontWeight: 700,
                                    color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
                                    fontSize: '0.75rem'
                                  }}
                                >
                                  Niveau de réinjection
                                </TableCell>
                                {qualification.map((status) => (
                                  <TableCell
                                    key={status}
                                    align="right"
                                    sx={{
                                      fontWeight: 700,
                                      color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
                                      fontSize: '0.75rem'
                                    }}
                                  >
                                    {status}
                                  </TableCell>
                                ))}
                                <TableCell
                                  align="right"
                                  sx={{
                                    fontWeight: 700,
                                    color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
                                    fontSize: '0.75rem'
                                  }}
                                >
                                  Total
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {row.historic !== undefined && (
                                Object.keys(row.historic).map((histoData) => (
                                  <TableRow key={histoData} hover>
                                    <TableCell align="right" sx={{ fontWeight: 600, color: theme.palette.text.secondary }}>
                                      {histoData}
                                    </TableCell>
                                    {Object.keys(row.historic[histoData]).map((status) => (
                                      <TableCell key={status} align="right" sx={{ color: theme.palette.text.secondary }}>
                                        {row.historic[histoData][status] === undefined || row.historic[histoData][status].number === null ? 0 : row.historic[histoData][status].number}
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                ))
                              )}
                            </TableBody>
                          </Table>
                        </Box>
                      </Collapse>
                    </TableCell>
                  )}
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

CampaignStatusList.propTypes = {
  statusAndSource: PropTypes.object.isRequired,
  qualification: PropTypes.array.isRequired,
};

export default CampaignStatusList;
